import api from '../../components/api'

export type SettledPaymentsCount = {
  settledPaymentsCount: number
}

export const getSettledPaymentsCount = async (): Promise<SettledPaymentsCount> => {
  return (await api.get('/web/invoicing/settled-payments-count')).data
}
